'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var LocalizationMixin = require('../../localization/CommonLocalizationMixin');
var accessibilityHelper = require('../../lib/ADAHelpers');

var RemoveCardModal = createReactClass({
    displayName: 'RemoveCardModal',
    mixins: [LocalizationMixin],

    propTypes: {
        hideModal: PropTypes.func.isRequired,
        focusElementAfterMount: PropTypes.func
    },

    hideModal: function hideModal() {
        // Actions.hideGenericModal();
        // document.querySelector('#qa-remove-card').focus();

        this.props.hideModal();
    },

    componentDidMount: function componentDidMount() {
        document.querySelector('#remove-card-modal-no').focus();
        accessibilityHelper.focusOnElementAfterModalTransition('#remove-card-modal-no', 'open');

        if (this.props.focusElementAfterMount) this.props.focusElementAfterMount();
        // focusOnElementAfterModalTransition('#qa-remove-card', 'close');
    },

    handleKeyDown: function handleKeyDown(e) {
        if (e.keyCode === 27) {
            e.preventDefault();
            e.stopPropagation();
            this.hideModal();
        } else {
            accessibilityHelper.keepTrappedInModal(e, document.querySelector('#offer-modal-close-btn'), document.querySelector('.qa-remove-card-modal-yes'));
        }
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: 'qa-remove-card-modal', onKeyDown: this.handleKeyDown, role: 'dialog', 'aria-labelledby': 'remove-card-modal-heading',
                'aria-describedby': 'remove-card-modal-description' },
            React.createElement(
                'div',
                { className: 'modal-header' },
                React.createElement(
                    'button',
                    { type: 'button', className: 'close', onClick: this.hideModal, id: 'offer-modal-close-btn' },
                    React.createElement(
                        'span',
                        { 'aria-hidden': 'true' },
                        '\xD7'
                    ),
                    React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Close'
                    )
                )
            ),
            React.createElement(
                'div',
                { className: 'modal-body' },
                React.createElement(
                    'div',
                    { className: 'row' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        React.createElement(
                            'h1',
                            { id: 'remove-card-modal-heading' },
                            this.getLocalizedText('payment_options_remove_your_card')
                        ),
                        React.createElement('hr', null)
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        React.createElement(
                            'p',
                            { id: 'remove-card-modal-description' },
                            this.getLocalizedText('payment_options_are_you_sure_remove')
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        React.createElement('input', { onClick: this.hideModal, type: 'button',
                            className: 'btn btn-default full-width qa-remove-card-modal-no',
                            value: this.getLocalizedText('payment_options_no'),
                            id: 'remove-card-modal-no' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        React.createElement('input', { onClick: this.props.submit, type: 'button',
                            className: 'btn btn-primary full-width qa-remove-card-modal-yes',
                            value: this.getLocalizedText('payment_options_yes') })
                    )
                )
            )
        );
    }
});

module.exports = RemoveCardModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/modals/removeCardModal.js
// module id = 832
// module chunks = 0